import { loadData } from "./LoadData";
import { getLegacySelectionData } from "./GetLegacySelectionData";
import { BFFGateway, internalMessageBus, BetSlipViewsChannels } from "./Dependencies";
import { BetType } from "sb-betslip-bl-contracts";
import { BsUtilReceivers, BetslipUtilChannels } from "sb-betslip-utils-contracts";
/*istanbul ignore file*/
export const BetSlipUtilExtend = (window, BFFGateway, internalMessageBus, BetSlip) => {
    $.extend(window.BetSlipUtil, (function () {
        var api = {};
        var uniSlip = getUniSlip();
        var bffGateway = new BFFGateway();
        var BetSlipActions = {
            Add: 0,
            Remove: 1,
            Clear: 2,
            Status: 3
        };
        function getUniSlip() {
            uniSlip = uniSlip || (typeof BetSlip !== "undefined" ? BetSlip : undefined);
            return uniSlip;
        }
        var BetSlipViewsChannelsHandlers = {
            subscribe() {
                internalMessageBus.on(BetSlipViewsChannels.Listen.addSelection, api.processMessage);
                internalMessageBus.on(BetSlipViewsChannels.Listen.removeSelection, api.processMessage);
                internalMessageBus.on(BetSlipViewsChannels.Listen.clear, api.processMessage);
                internalMessageBus.on(BetSlipViewsChannels.Listen.status, api.processMessage);
            },
            unsubscribe() {
                internalMessageBus.off(BetSlipViewsChannels.Listen.addSelection, api.processMessage);
                internalMessageBus.off(BetSlipViewsChannels.Listen.removeSelection, api.processMessage);
                internalMessageBus.off(BetSlipViewsChannels.Listen.clear, api.processMessage);
                internalMessageBus.off(BetSlipViewsChannels.Listen.status, api.processMessage);
            }
        };
        window.addEventListener("load", BetSlipViewsChannelsHandlers.subscribe);
        window.addEventListener("unload", BetSlipViewsChannelsHandlers.unsubscribe);
        var comparers = {
            comparePoints(item, meID, evID, rowTypeID, lineTypeID, points) {
                /* tslint:disable:triple-equals */
                return item.Points == points
                    && item.LineTypeID == lineTypeID
                    && item.BetSide == rowTypeID
                    && item.EventID == evID
                    && item.MasterEventID == meID;
            },
            compareRegularLines(item, meID, evID, lgID, lineID) {
                /* tslint:disable:triple-equals */
                return item.LineID == lineID && item.LineGroupID == lgID && item.EventID == evID && item.MasterEventID == meID;
            },
            compareLiveLines(item, meID, evID, lgID, side, betTypeID) {
                /* tslint:disable:triple-equals */
                return item.LineGroupID == lgID &&
                    item.EventID == evID &&
                    item.MasterEventID == meID &&
                    item.BetSide == side &&
                    item.BetTypeID == betTypeID;
            },
            compareQALines(item, lineID, eventID, masterEventID) {
                /* tslint:disable:triple-equals */
                return item.LineID == lineID && item.EventID == eventID && item.MasterEventID == masterEventID;
            },
            compareLiveQALines(item, meID, evtID, lineID) {
                /* tslint:disable:triple-equals */
                return item.MasterEventID == meID && item.EventID == evtID && item.LineID == lineID;
            }
        };
        function isPointsCompare(points) {
            return points !== undefined && points !== null;
        }
        //Lines.js(Mobile) - isPointsInSlip
        /* jshint maxparams: 5 */
        var isPointsInSlip = function (meID, evID, rowTypeID, lineTypeID, points) {
            var i = uniSlip.Selections.length, item;
            while (i > 0) {
                i -= 1;
                item = uniSlip.Selections[i];
                // when bet comes from Open Bets it has BetID and we need to skip it
                if (!item || item.BetID) {
                    continue;
                }
                if (comparers.comparePoints(item, meID, evID, rowTypeID, lineTypeID, points)) {
                    return true;
                }
            }
            return false;
        };
        //Lines.js(Mobile) - isInSlip
        /* jshint maxparams: 4 */
        var isInSlip = function (meID, evID, lgID, lineID) {
            var i = uniSlip.Selections.length, item;
            while (i > 0) {
                i -= 1;
                item = uniSlip.Selections[i];
                // when bet comes from Open Bets it has BetID and we need to skip it
                if (!item || item.BetID) {
                    continue;
                }
                if (comparers.compareRegularLines(item, meID, evID, lgID, lineID)) {
                    return true;
                }
            }
            return false;
        };
        /* jshint maxparams: 3 */
        //Lines.js(Mobile) - isLiveInSlip
        /* jshint maxparams: 5 */ // TODO: Refactor to reduce number of params!
        /* tslint:disable:triple-equals */
        var isLiveInSlip = function (meID, evID, lgID, side, betTypeID) {
            var i = uniSlip.Selections.length, item;
            while (i > 0) {
                i -= 1;
                item = uniSlip.Selections[i];
                // when bet comes from Open Bets it has BetID and we need to skip it
                if (!item || item.BetID) {
                    continue;
                }
                /* tslint:disable:triple-equals */
                if (comparers.compareLiveLines(item, meID, evID, lgID, side, betTypeID)) {
                    return true;
                }
            }
            return false;
        };
        /* jshint maxparams: 3 */
        // QAEventInfo.js(Mobile) - isQAInSlip
        var isQAInSlip = function (masterEventID, eventID, lineID) {
            var i = uniSlip.Selections.length, item;
            while (i > 0) {
                i -= 1;
                item = uniSlip.Selections[i];
                // when bet comes from Open Bets it has BetID and we need to skip it
                if (!item || item.BetID) {
                    continue;
                }
                /* tslint:disable:triple-equals */
                if (comparers.compareQALines(item, lineID, eventID, masterEventID)) {
                    return true;
                }
            }
            return false;
        };
        //QALine.js(Mobile) - isLiveQAInSlip
        var isLiveQAInSlip = function (meID, evtID, lineID) {
            var i = uniSlip.Selections.length, item;
            while (i > 0) {
                i -= 1;
                item = uniSlip.Selections[i];
                // when bet comes from Open Bets it has BetID and we need to skip it
                if (!item || item.BetID) {
                    continue;
                }
                /* tslint:disable:triple-equals */
                if (comparers.compareLiveQALines(item, meID, evtID, lineID)) {
                    return true;
                }
            }
            return false;
        };
        var hasData = function (subChannels, channel) {
            return subChannels.indexOf(channel) !== -1;
        };
        var getBetslipAction = function (subChannels) {
            var getAction = function (message) {
                var splittedMessage = message.split(".");
                return splittedMessage[splittedMessage.length - 1];
            };
            var shouldAdd = hasData(subChannels, getAction(BetSlipViewsChannels.Listen.addSelection));
            var shouldRemove = hasData(subChannels, getAction(BetSlipViewsChannels.Listen.removeSelection));
            var shouldClear = hasData(subChannels, getAction(BetSlipViewsChannels.Listen.clear));
            var shouldGetStatus = hasData(subChannels, getAction(BetSlipViewsChannels.Listen.status));
            if (shouldAdd) {
                return BetSlipActions.Add;
            }
            if (shouldRemove) {
                return BetSlipActions.Remove;
            }
            if (shouldClear) {
                return BetSlipActions.Clear;
            }
            if (shouldGetStatus) {
                return BetSlipActions.Status;
            }
        };
        var getMessageHandler = function (action) {
            var handler;
            switch (action) {
                case BetSlipActions.Add:
                    handler = api.addSelection;
                    break;
                case BetSlipActions.Remove:
                    handler = api.removeSelection;
                    break;
            }
            return handler;
        };
        var getSelectionType = function (selection) {
            let selectionType = "Regular";
            switch (selection.BetTypeID) {
                case BetType.Forecast:
                    selectionType = "Forecast";
                    break;
                case BetType.Tricast:
                    selectionType = "Tricast";
                    break;
            }
            return selectionType;
        };
        var shouldHideEachWay = function () {
            return typeof BetSlipRegulations !== "undefined" && BetSlipRegulations.hasOwnProperty("HideEachWay") && BetSlipRegulations.HideEachWay == true;
        };
        /* jshint maxparams: 13 */ // TODO: Refactor to reduce number of params!
        api.addOddLive = function (masterEventID, eventID, LineGroupID, lineTypeID, rowtypeid, Odds, Points, lineID, eventTypeId, isFavTeam, leagueId, betId) {
            /* tslint:disable:no-null-keyword */
            var liveSelection = new RegularLiveSlipSelection(masterEventID, eventID, LineGroupID, lineTypeID, rowtypeid, Odds, Points, 0, 0, null, eventTypeId, isFavTeam, leagueId);
            liveSelection.LineID = lineID || 0;
            liveSelection.BetID = betId;
            BetSlip.add(liveSelection);
            return liveSelection;
        };
        /* jshint maxparams: 13 */ // TODO: Refactor to reduce number of params!
        api.addOddRegular = function (masterEventID, eventID, LineGroupID, lineTypeID, rowtypeid, Odds, Points, lineId, eventTypeId, favTeam, isPreloaded, leagueId, betId) {
            var selObj = new RegularSlipSelection(masterEventID, eventID, LineGroupID, lineId, Odds, Points, eventTypeId, favTeam, leagueId, lineTypeID);
            selObj.BetTypeID = lineTypeID;
            selObj.BetSide = rowtypeid;
            selObj.BetID = betId;
            BetSlip.add(selObj, isPreloaded);
        };
        api.addOddQALive = function (masterEventID, eventID, lineID, Odds, eventTypeId, isPreloaded, leagueId, betId) {
            var selObj = new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, 0, 0, eventTypeId, leagueId);
            selObj.BetID = betId;
            BetSlip.add(selObj, isPreloaded);
        };
        api.addOddQARegular = function (masterEventID, eventID, lineID, Odds, eventTypeId, isPreloaded, leagueId, betId) {
            var selObj = new QASlipSelection(masterEventID, eventID, lineID, Odds, eventTypeId, leagueId);
            selObj.BetID = betId;
            BetSlip.add(selObj, isPreloaded);
        };
        /* jshint maxparams: 3 */
        api.addQAInitilizedSelectionToBetSlip = function (data) {
            var previousModeID = BetSlip.CurrentMode.ID;
            for (var i = 0; i < data.lines.length; i += 1) {
                var item = data.lines[i];
                BetSlip.selectSlipMode("pulse");
                var selection = new QALiveSlipSelection(item.masterEventId, item.eventId, item.lineId, item.odds, item.score1, item.score2, item.eventTypeId, item.leagueId);
                selection.processBetUpdate({
                    BranchID: item.branchId,
                    BranchName: item.branchName,
                    LeagueID: item.leagueId,
                    EventTypeID: item.eventTypeId,
                    EventTypeName: item.eventTypeName,
                    OppositeEventTypeID: item.oppositeEventTypeId,
                    EventName: item.eventName,
                    Team1Name: item.team1Name,
                    Team2Name: item.team2Name,
                    LiveGroupID: item.liveGroupId,
                    PreLiveGroupID: item.preLiveGroupId,
                    maxBet: item.maxBet,
                    minBet: item.minBet,
                    waitingAllowed: item.waitingAllowed,
                    MaxBetCombo: item.maxBetCombo,
                    MaxBetSystem: item.maxBetSystem,
                    MaxBetTeaser: item.maxBetTeaser,
                    MaxRisk: item.maxRisk,
                    MaxRiskCombo: item.maxRiskCombo,
                    MaxRiskSystem: item.maxRiskSystem,
                    MaxRiskTeaser: item.maxRiskTeaser,
                    MaxRiskComboEachWay: item.maxRiskComboEachWay,
                    MaxStakeComboEachWay: item.maxStakeComboEachWay,
                    SingleSelectionRisk: item.singleSelectionRisk,
                    RealOrPresumptiveOdds: item.realOrPresumptiveOdds,
                    MaxBetForCustomer: item.maxBetForCustomer,
                    SingleBetIsEnabled: item.singleBetIsEnabled,
                    ComboBetIsEnabled: item.comboBetIsEnabled,
                    SystemBetIsEnabled: item.systemBetIsEnabled,
                    TeaserBetIsEnabled: item.teaserBetIsEnabled,
                    IsTeamSwapEnabled: item.isTeamSwapEnabled,
                    LineTypeName: item.lineTypeName,
                    EventDate: item.eventDate,
                    BetTypeID: item.betTypeId,
                    LineTypeID: item.lineTypeId,
                    UseEventName: item.useEventName,
                    LineName: item.LineName,
                    AsianLineName: item.asianLineName,
                    MappedLineTypeID: item.mappedLineTypeId,
                    Swapped: item.swapped,
                    SplitType: item.splitTypeId,
                    SISEventID: item.SISEventId,
                    GBSEventID: item.GBSEventId,
                    FeedEventID: item.feedEventId,
                    FeedProviderID: item.feedProviderId,
                    QAParameter1: item.qaParameter1,
                    QAParameter2: item.qaParameter2,
                    HasGameStarted: true
                });
                selection.ViewKey = BetSlip.getViewKey();
                BetSlip.Selections[selection.ViewKey] = selection;
            }
            BetSlip.CurrentMode.Deposit = data.stake;
            BetSlip.CurrentMode.placeBets(item.eventTypeId);
            BetSlip.selectSlipMode(previousModeID);
        };
        api.getAvailableFreeBetsForPulse = function (data) {
            var pulseBetEvent = {
                HasGameStarted: true,
                BranchID: data.branchId,
                LeagueID: data.leagueId,
                EventTypeID: data.typeId,
                Live: true,
                MasterEventID: data.masterEventId,
                BetType: 25,
                Odds: data.odds
            };
            return BetSlip.Modes["pulse"] && BetSlip.Modes["pulse"].getAvailableFreeBets(pulseBetEvent, false);
        };
        api.removeAllSelectedFreePulseBets = function () {
            BetSlip.Modes["pulse"] && BetSlip.Modes["pulse"].removeAllSelectedFreePulseBets();
        };
        api.clearAll = function () {
            UniSlipBlock.clear();
        };
        api.addSelection = function (betslipSelection) {
            !api.isOddInSlip(betslipSelection.masterEventID, betslipSelection.eventID, betslipSelection.lineID, betslipSelection.lineGroupID, betslipSelection.rowTypeID, betslipSelection.lineTypeID, betslipSelection.isLive, betslipSelection.isQA, betslipSelection.points) && api.addOddToSlip(betslipSelection.masterEventID, betslipSelection.eventID, betslipSelection.lineID, betslipSelection.odds, betslipSelection.lineGroupID, betslipSelection.lineTypeID, betslipSelection.rowTypeID, betslipSelection.points, betslipSelection.isLive, betslipSelection.isQA, betslipSelection.eventTypeId, betslipSelection.leagueId, betslipSelection.betId, betslipSelection.preventUpdating, betslipSelection.isFavedTeam, betslipSelection.qaParameter1, betslipSelection.qaParameter2);
            api.getChosenBet(betslipSelection.lineID, betslipSelection.isQA, true);
        };
        api.removeSelection = function (betslipSelection) {
            api.isOddInSlip(betslipSelection.masterEventID, betslipSelection.eventID, betslipSelection.lineID, betslipSelection.lineGroupID, betslipSelection.rowTypeID, betslipSelection.lineTypeID, betslipSelection.isLive, betslipSelection.isQA, betslipSelection.points) && api.addOddToSlip(betslipSelection.masterEventID, betslipSelection.eventID, betslipSelection.lineID, betslipSelection.odds, betslipSelection.lineGroupID, betslipSelection.lineTypeID, betslipSelection.rowTypeID, betslipSelection.points, betslipSelection.isLive, betslipSelection.isQA, betslipSelection.eventTypeId, betslipSelection.leagueId, betslipSelection.betId, betslipSelection.preventUpdating, betslipSelection.isFavedTeam, betslipSelection.qaParameter1, betslipSelection.qaParameter2);
            api.getChosenBet(betslipSelection.lineID, betslipSelection.isQA, false);
        };
        api.getChosenBet = function (lineID, isQA, addChosenBetClass) {
            const uniqueOddClass = getUniqueOddsClass(lineID, isQA);
            const buttons = document.getElementsByClassName(uniqueOddClass);
            const len = buttons.length;
            for (let i = 0; i < len; i++) {
                addChosenBetClass ? buttons[i].classList.add("chosenBet") : buttons[i].classList.remove("chosenBet");
            }
        };
        api.getSelections = function () {
            var messageItems = [];
            var selections = Application.IsNativeApp() ?
                BetSlip.Selections.filter(sel => sel && !(!sel.VisibleCastSelection && sel.CastSelection)) : BetSlip.Selections;
            selections.forEach(function (s) {
                messageItems.push({
                    eventId: BetSlip.getSDEventId(s),
                    marketId: BetSlip.getSDMarketId(s),
                    selectionId: BetSlip.getSDSelectionId(s),
                    type: getSelectionType(s)
                });
            });
            return {
                receiverIds: ["FullBetSlip"],
                items: messageItems
            };
        };
        /*globals addQAOdd, addOdd */
        /* jshint maxcomplexity: 6, maxparams: 14 */ // TODO: Refactor to reduce complexity!
        api.addOddToSlip = function (masterEventID, eventID, lineID, odds, lineGroupID, lineTypeID, rowTypeID, points, isLive, isQA, eventTypeId, leagueId, betId, preventUpdating, isFavedTeam, qaParameter1, qaParameter2) {
            var isPreloaded = BetSlip.IsInEditMode || preventUpdating;
            if (!getUniSlip()) {
                return false;
            }
            if (isLive) {
                if (isQA) {
                    // masterEventID - LiveMasterEvent.ID, eventID - LiveQAEventInfo.ID, lineID - QALine.ID, Odds - QALine.Odds
                    return addOddQALive(masterEventID, eventID, lineID, odds, eventTypeId, isPreloaded, leagueId, betId, lineTypeID, qaParameter1, qaParameter2);
                }
                else {
                    /* masterEventID - LiveMasterEvent.ID or LiveEventInfo.MasterEventID(in Mobile); eventID - LiveEventInfo.ID;
                       lineGroupID - LineGroup.ID; lineTypeID - hard-coded values of MLOdds(HCOdds or OUOdds).BetType;
                       rowTypeID - 1(Team 1), 2(Draw) or 3(Team 2);
                       odds - MLOdds(HCOdds or OUOdds)-> ML1_Odds, ML2_Odds or ML3_Odds(Odds1 or Odds3);
                       points - positive or negative values of MLOdds(HCOdds or OUOdds).Points1 */
                    return api.addOddLive(masterEventID, eventID, lineGroupID, lineTypeID, rowTypeID, odds, points, lineID, eventTypeId, isFavedTeam, leagueId, betId);
                }
            }
            else {
                if (isQA) {
                    // masterEventID - MasterEvent.ID, eventID - QAEventInfo.ID, lineID - QALine.ID, odds - QALine.Odds
                    return addQAOdd(masterEventID, eventID, lineID, odds, eventTypeId, isPreloaded, leagueId, betId, lineTypeID, qaParameter1, qaParameter2);
                }
                else {
                    /* masterEventID - MasterEvent.ID; eventID - EventInfo.ID, lineGroupID - LineGroup.ID;
                       lineID - MLOdds(HCOdds, OUOdds)-> ML1_ID, ML2_ID or ML3_ID(ID1 or ID3);
                       odds - MLOdds(HCOdds or OUOdds)-> ML1_Odds, ML2_Odds or ML3_Odds(Odds1 or Odds3);
                       points - positive or negative values of MLOdds(HCOdds or OUOdds).Points1 */
                    return addOdd(masterEventID, eventID, lineGroupID, lineID, odds, points, eventTypeId, isFavedTeam, isPreloaded, leagueId, betId, lineTypeID, rowTypeID);
                }
            }
        };
        /* jshint maxcomplexity: 5, maxparams: 3 */
        /* jshint maxcomplexity: 6 */ // TODO: Refactor to reduce complexity!
        /* jshint maxparams: 9 */ // TODO: Refactor to reduce number of params!
        api.isOddInSlip = function (masterEventID, eventID, lineID, lineGroupID, rowTypeID, lineTypeID, isLive, isQA, points) {
            if (!getUniSlip()) {
                return false;
            }
            if (isLive) {
                if (isQA) {
                    // masterEventID - LiveMasterEvent.ID, eventID - LiveQAEventInfo.ID, lineID - QALine.ID
                    return isLiveQAInSlip(masterEventID, eventID, lineID);
                }
                if (isPointsCompare(points)) {
                    return isPointsInSlip(masterEventID, eventID, rowTypeID, lineTypeID, points);
                }
                /* masterEventID - LiveMasterEvent.ID or LiveEventInfo.MasterEventID(in Mobile); eventID - LiveEventInfo.ID;
                   lineGroupID - LineGroup.ID; rowTypeID - 1(Team 1), 2(Draw) or 3(Team 2);
                   lineTypeID - hard-coded values of MLOdds(HCOdds or OUOdds).BetType; */
                return isLiveInSlip(masterEventID, eventID, lineGroupID, rowTypeID, lineTypeID);
            }
            if (isQA) {
                // masterEventID - MasterEvent.ID, eventID - QAEventInfo.ID, lineID - QALine.ID
                return isQAInSlip(masterEventID, eventID, lineID);
            }
            /* masterEventID - MasterEvent.ID; eventID - EventInfo.ID, lineGroupID - LineGroup.ID;
               lineID - MLOdds(HCOdds, OUOdds)-> ML1_ID, ML2_ID or ML3_ID(ID1 or ID3); */
            return isInSlip(masterEventID, eventID, lineGroupID, lineID);
        };
        var tryRemoveHRBet = function (item) {
            if (item["legacy"]) {
                for (var key in BetSlip.Selections) {
                    if (BetSlip.Selections[key].EventID == item.eventId && BetSlip.Selections[key].LineID == item["legacy"].selectionId) {
                        BetSlip.add(BetSlip.Selections[key]);
                    }
                }
                return true;
            }
            else {
                return false;
            }
        };
        api.createQAOddHRParams = function (event, line, odds, racingRegionId, isOtherHR) {
            if (!racingRegionId) {
                var branchBlockRegionID = typeof RacingBranchBlock !== "undefined" ? window.RacingBranchBlock.Current.CurrentRegionID : 0;
                var gameBlockRegionID = typeof window.RacingGameBlock !== "undefined" ? window.RacingGameBlock.Current.CurrentRegionID : 0;
                racingRegionId = branchBlockRegionID ? branchBlockRegionID : gameBlockRegionID;
            }
            return {
                event: {
                    ID: event.ID,
                    TypeID: event.Type,
                    LeagueID: event.LeagueID,
                    BranchID: event.BranchID,
                    RaceProgress: event.RaceProgress
                },
                line: {
                    ID: line.ID,
                    LineTypeID: line.LineTypeID,
                    QATypeParameter1: line.QATypeParameter1,
                    QATypeParameter2: line.QATypeParameter2,
                    Odds: line.Odds,
                    AlternativeLineID: line.AlternativeLineId
                },
                isOtherHR: isOtherHR || false,
                racingRegionId
            };
        };
        var createQAHRMsgItem = function (qaBetParams) {
            var event = qaBetParams.event, line = qaBetParams.line;
            return {
                eventId: event.ID.toString(),
                marketId: event.ID.toString(),
                selectionId: getSDQASelectionIdFromLine(line, event.ID, event.LeagueID),
                sportId: event.BranchID.toString(),
                type: "Regular",
                selectionPresentationInfo: {
                    isLive: true
                },
                alternativeSelections: line.AlternativeLineID ? [{
                        id: line.AlternativeLineID
                    }] : undefined,
                legacy: {
                    isOtherHR: qaBetParams.isOtherHR,
                    selectionId: line.ID,
                    eventTypeId: event.TypeID,
                    racingMode: event.RaceProgress,
                    racingRegionId: qaBetParams.racingRegionId,
                    odds: line.Odds
                }
            };
        };
        /*jshint maxparams: 1 */
        api.addQAOddHRMsgItem = function (qaBetParams) {
            var item = createQAHRMsgItem(qaBetParams);
            return internalMessageBus.emit(api.getMsgItemChannel(item), {
                receiverIds: [],
                items: [item]
            });
        };
        /* jshint maxcomplexity: 5 */
        /* jshint maxparams: 3 */
        api.sendQAOddHRMsgItem = function (event, line, racingRegionId) {
            const item = createQAHRMsgItem(Object.assign({ event, line, racingRegionId }, { isOtherHR: true }));
            return internalMessageBus.emit(api.getMsgItemChannel(item), {
                receiverIds: [],
                items: [item]
            });
        };
        api.getMsgItemChannel = function (item) {
            var selection = api.getSelections().items.find(sel => sel &&
                sel.marketId == item.marketId &&
                sel.eventId == item.eventId &&
                sel.selectionId == item.selectionId);
            return selection
                ? BetslipUtilChannels.Listen.Commands.remove_items
                : BetslipUtilChannels.Listen.Commands.add_items;
        };
        /* jshint maxparams: 1 */
        api.handleQAOddHRMessage = function (item) {
            const legacy = item["legacy"];
            api.addQAOddHR(0, item.eventId, legacy.selectionId, legacy.odds, legacy.racingRegionId, legacy.racingMode, Number(legacy.eventTypeId));
        };
        /* jshint maxparams: 8 */
        api.addQAOddHR = function (masterEventID, eventID, lineID, Odds, RacingRegionID, RacingMode, eventTypeId) {
            /*globals QASlipSelection */
            var qaBet = new QASlipSelection(masterEventID, eventID, lineID, Odds, eventTypeId);
            qaBet.RacingRegionID = RacingRegionID;
            qaBet.RacingMode = RacingMode;
            BetSlip.add(qaBet);
        };
        api.subscribeOnSelectionRemoved = function (subscriberId, handler) {
            BetSlip.OnSelectionRemoved[subscriberId] = function (message) {
                if (!message.isFromBlocks) {
                    message.items.map(function (selection) {
                        handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
                    });
                }
            };
        };
        api.subscribeOnSelectionAdded = function (subscriberId, handler) {
            BetSlip.OnAdd[subscriberId] = function (sender, selection) {
                handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
            };
        };
        api.addMultiLineOddToSlip = function (masterEventID, eventID, lineID, Odd, variants, eventTypeId, isVirtual) {
            if (!getUniSlip()) {
                return false;
            }
            /*globals addMultiLineOdd */
            addMultiLineOdd(masterEventID, eventID, lineID, Odd, variants, eventTypeId, isVirtual);
        };
        api.addPulseBet = function (masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId, stake) {
            if (!getUniSlip()) {
                return false;
            }
            BetSlip.clear(); // it clears all selections in BetSlip before adding the pulse bet selections
            BetSlip.restoreSlipMode("pulse");
            BetSlip.CurrentMode.placeBet();
            //add selections to BetSlip
            setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), stake);
            setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), 0);
            setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), 0);
        };
        var setPulseBetSelectionAndDeposit = function (selection, deposit) {
            var viewKey = BetSlip.getViewKey();
            BetSlip.Selections[viewKey] = selection;
            BetSlipUtil.CurrentMode.setDeposit(viewKey, deposit);
        };
        api.getAllBetsDepositValue = function (mode) {
            // First we remove the undefined entries inside the deposits array
            var allBets = mode.Deposits.filter(function (n) { return n !== undefined; }), allBetsCount = allBets.length;
            //We need to check if there are selections that are part ot multi line but not present as singles and remove them from the bets count
            //because when adding multi lines we add the selections that make it with 0 deposit and this leeds to wrong calculations for all bets
            if (BetSlip.Selections.any(function (sel) { return sel.IsMultiLine; })) {
                var castSelections = Array.findAll(BetSlip.Selections, function (sel) { return sel.CastSelection && !sel.VisibleCastSelection; });
                allBetsCount = allBetsCount - Array.getLength(castSelections);
            }
            if (allBetsCount > 0) {
                // Here we check mathematically if all the elements are equal
                var allElementsSum = allBets.reduce(function (prev, cur) { return prev + cur; }), betsDelta = allElementsSum / allBetsCount;
                /* tslint:disable:no-null-keyword */
                if (betsDelta === Math.max.apply(null, allBets)) {
                    mode.AllBetsDeposit = betsDelta;
                }
                else {
                    mode.AllBetsDeposit = 0;
                }
            }
            else {
                mode.AllBetsDeposit = 0;
            }
        };
        api.sendQACastMsgItems = function (event) {
            if (!event) {
                return false;
            }
            if (!event.canPlaceForecastBet()) {
                return false;
            }
            const items = [
                ...Object.entries(event.ForecastSelection)
                    .map(([lineID, pos]) => getCastMessageItem(event, lineID, pos, "Forecast")),
                ...Object.entries(event.TricastSelection)
                    .map(([lineID, pos]) => getCastMessageItem(event, lineID, pos, "Tricast"))
            ];
            internalMessageBus.emit(BetslipUtilChannels.Listen.Commands.add_items, {
                receiverIds: [],
                items
            });
            return true;
        };
        function getCastMessageItem(event, lineId, pos, type) {
            return {
                eventId: event.ID.toString(),
                marketId: event.ID.toString(),
                selectionId: getSDQASelectionIdFromLine(event.Lines[lineId], event.ID, event.LeagueID),
                racingCastBetPosition: pos,
                type,
                sportId: event.BranchID.toString(),
                legacy: {
                    selectionId: lineId
                }
            };
        }
        function getSDQASelectionIdFromLine(line, eventId, leagueId) {
            return BetSlip.createSDQASelectionId(eventId, line.ID, line.LineTypeID, leagueId, line.QATypeParameter1, line.QATypeParameter2);
        }
        ;
        api.handleForcastTricastMessage = function (msgItems) {
            window.PageMethods.UpdateHREvents(msgItems[0].eventId, window.UseAustralianHorseRacingView, (result) => {
                const event = reproduceCastEvent(result, msgItems);
                this.processQACastBet(event);
            });
        };
        var reproduceCastEvent = function (result, msgItems) {
            const rawEvent = eval(result)[0];
            const sportId = msgItems[0].sportId;
            const event = sportId === eBranches.VirtualSports_.toString()
                ? new window.VirtualHorseRacingEventInfo(rawEvent, sportId)
                : new window.RacingEventInfo(rawEvent);
            event.updateFromServer(rawEvent);
            const forcastLinePositions = {};
            const tricastLinePositions = {};
            msgItems.forEach(item => {
                if (item.type === "Forecast") {
                    forcastLinePositions[item["legacy"].selectionId] = item.racingCastBetPosition;
                }
                else if (item.type === "Tricast") {
                    tricastLinePositions[item["legacy"].selectionId] = item.racingCastBetPosition;
                }
            });
            Object.assign(event, {
                ForecastSelection: forcastLinePositions,
                TricastSelection: tricastLinePositions
            });
            return event;
        };
        /* jshint maxparams: 3 */
        /* jshint maxcomplexity: 5 */
        api.processQACastBet = function (event) {
            if (!event) {
                return false;
            }
            if (!event.canPlaceForecastBet()) {
                return false;
            }
            var Odd = 0; // ???
            var lineID = 0; // ???
            var foreVariants = generateCastVariants(event.ForecastSelection, event, false);
            if (foreVariants) {
                /* tslint:disable:no-null-keyword */
                this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, foreVariants, getEventTypeId(null, event), VirtualSports.isBranchVirtual(event.BranchID));
            }
            var triVariants = generateCastVariants(event.TricastSelection, event, true);
            if (triVariants) {
                /* tslint:disable:no-null-keyword */
                this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, triVariants, getEventTypeId(null, event), VirtualSports.isBranchVirtual(event.BranchID));
            }
            return true;
        };
        /* tslint:disable:cyclomatic-complexity */
        api.addExoticBet = function (event) {
            if (!event || !event.canPlaceExoticBet()) {
                return false;
            }
            var Odd = 0; // ???
            var lineID = 0; // ???
            event.buildExotic();
            var bets = event.getCurrentExoticBets();
            if (event.ExoticType == "Quinella") {
                var quinellaSelection = bets[0];
                var quinellaVariants = generateCastVariants(quinellaSelection, event, false);
                if (quinellaVariants) {
                    /* tslint:disable:no-null-keyword */
                    this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, quinellaVariants, getEventTypeId(null, event));
                }
            }
            else {
                for (var i = 0; i < bets.length; i += 1) {
                    var bet = bets[i];
                    var exoticVariants = generateExoticVariants(bet, event);
                    if (exoticVariants) {
                        /* tslint:disable:no-null-keyword */
                        this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, exoticVariants, getEventTypeId(null, event));
                    }
                }
            }
            return true;
        };
        var getExoticEventMaxBet = function (event) {
            switch (event.ExoticType) {
                case "Quinella":
                case "Exacta":
                    return event.ForecastMaxBet;
                case "Trifecta":
                    return event.TricastMaxBet;
                case "FirstFour":
                    return event.FirstFourMaxBet;
            }
        };
        /* tslint:disable:cyclomatic-complexity */
        /* tslint:disable:forin */
        var generateExoticVariants = function (selection, event) {
            var minSelections = event.getColumnsCount();
            if (Array.getLength(selection) < minSelections) {
                return false;
            }
            var groupPositions = [];
            var castSelections = [];
            var cb;
            var vk;
            var groupSize = minSelections;
            var maxBet = getExoticEventMaxBet(event);
            var lines = [];
            for (var idx in selection) {
                lines.push(event.Lines[idx]);
            }
            lines = getSortedLines(lines, event.RacecardInfo);
            for (var i = 0; i < Array.getLength(lines); i += 1) {
                var line = lines[i];
                /* tslint:disable:no-null-keyword */
                cb = new QASlipSelection(line.MasterEventID, event.ID, line.ID, line.Odds, getEventTypeId(null, event));
                cb.CastSelection = true;
                cb.LocationHash = location.hash;
                cb.EventDate = event.Date;
                vk = BetSlip.add(cb);
                if (vk === -1) {
                    /* tslint:disable:triple-equals */
                    var sel = Array.find(BetSlip.Selections, function (el) { return el.LineID === cb.LineID || el.AlternateLineID == cb.LineID; });
                    if (sel) {
                        vk = sel.ViewKey;
                        if (!sel.CastSelection) {
                            sel.CastSelection = true;
                            sel.VisibleCastSelection = true;
                        }
                    }
                }
                // -2 means the selection could not be added to the BetSlip
                if (vk === -2) {
                    for (let idx in castSelections) {
                        BetSlip.removeBet(castSelections[idx]);
                    }
                    return false;
                }
                var item = { ViewKey: vk, Position: selection[line.ID] };
                groupPositions.push(item);
                castSelections.push(vk);
                if (selection[line.ID] === 0) {
                    groupSize = -1;
                }
            }
            var groups = generateGroups(castSelections, groupSize, groupPositions);
            for (let item in groups) {
                groups[item].sort(chainSort(function (r1, r2) {
                    var x = Array.find(groupPositions, function (el) { return el.ViewKey === r1; });
                    var y = Array.find(groupPositions, function (el) { return el.ViewKey === r2; });
                    if (x !== null && y !== null) {
                        if (x.Position > y.Position) {
                            return 1;
                        }
                        if (x.Position < y.Position) {
                            return -1;
                        }
                        return 0;
                    }
                }));
            }
            var result = { Groups: groups, GroupPositions: groupPositions, EventDate: event.Date, MaxBet: maxBet, IsTriCast: false, PositionsCount: minSelections };
            return result;
        };
        /* jshint maxcomplexity: 5 */
        /* tslint:disable:cyclomatic-complexity */
        /* tslint:disable:forin */
        var generateCastVariants = function (selection, event, isTriCast) {
            var minSelections = (isTriCast ? 3 : 2);
            if (Array.getLength(selection) < minSelections) {
                return false;
            }
            var groupPositions = [];
            var castSelections = [];
            var cb;
            var vk;
            var groupSize = 2;
            var maxBet = event.ForecastMaxBet;
            if (isTriCast) {
                groupSize = 3;
                maxBet = event.TricastMaxBet;
            }
            var lines = [];
            for (var idx in selection) {
                lines.push(event.Lines[idx]);
            }
            lines = getSortedLines(lines, event.RacecardInfo);
            for (var i = 0; i < Array.getLength(lines); i += 1) {
                var line = lines[i];
                /* tslint:disable:no-null-keyword */
                cb = new QASlipSelection(line.MasterEventID, event.ID, line.ID, line.Odds, getEventTypeId(null, event));
                cb.CastSelection = true;
                cb.LocationHash = location.hash;
                cb.EventDate = event.Date;
                vk = BetSlip.add(cb);
                if (vk === -1) {
                    var sel = Array.find(BetSlip.Selections, function (el) { return el.LineID === cb.LineID || el.AlternateLineID == cb.LineID; });
                    if (sel) {
                        vk = sel.ViewKey;
                        if (!sel.CastSelection) {
                            sel.CastSelection = true;
                            sel.VisibleCastSelection = true;
                        }
                    }
                }
                // -2 means the selection could not be added to the BetSlip
                if (vk === -2) {
                    for (let idx in castSelections) {
                        BetSlip.removeBet(castSelections[idx]);
                    }
                    return false;
                }
                var item = { ViewKey: vk, Position: selection[line.ID] };
                groupPositions.push(item);
                castSelections.push(vk);
                if (selection[line.ID] === 0) {
                    groupSize = -1;
                }
            }
            var groups = generateGroups(castSelections, groupSize, groupPositions);
            for (let item in groups) {
                groups[item].sort(chainSort(function (r1, r2) {
                    var x = Array.find(groupPositions, function (el) { return el.ViewKey === r1; });
                    var y = Array.find(groupPositions, function (el) { return el.ViewKey === r2; });
                    if (x != undefined && y != undefined) {
                        if (x.Position > y.Position) {
                            return 1;
                        }
                        if (x.Position < y.Position) {
                            return -1;
                        }
                        return 0;
                    }
                }));
            }
            var result = { Groups: groups, GroupPositions: groupPositions, EventDate: event.Date, MaxBet: maxBet, IsTriCast: isTriCast };
            return result;
        };
        /* jshint maxcomplexity: 5 */
        var generateGroups = function (in_group, groupSize, groupPosition) {
            var subGroups = [];
            if (groupSize == -1) {
                subGroups.push(in_group);
                return subGroups;
            }
            else if (groupSize == 1) {
                for (var groupElemKey in in_group) {
                    subGroups.push([in_group[groupElemKey]]);
                }
            }
            else {
                for (var i = 0; i < in_group.length; i += 1) {
                    var tmpGroups = generateGroups(in_group.slice(i + 1), groupSize - 1, groupPosition);
                    for (var j in tmpGroups) {
                        var tmpGroup = tmpGroups[j];
                        var z = Array.find(tmpGroup, function (el) { return el == in_group[i]; });
                        if (z == undefined) {
                            var c = Array.find(groupPosition, function (el) { return el.ViewKey == in_group[i]; });
                            if (c) {
                                var tempArray = [];
                                for (var idx in tmpGroup) {
                                    var vk = tmpGroup[idx];
                                    var n = Array.find(groupPosition, function (el) { return el.ViewKey == vk; });
                                    if (n) {
                                        tempArray.push(n);
                                    }
                                }
                                var m = Array.find(tempArray, function (el) { return el.Position == c.Position; });
                                if (m == undefined) {
                                    tmpGroup.push(in_group[i]);
                                    subGroups.push(tmpGroup);
                                }
                            }
                        }
                    }
                }
            }
            return subGroups;
        };
        /* jshint maxcomplexity: 5 */
        /* tslint:disable:cyclomatic-complexity */
        var getSortedLines = function (lines, racecardInfo) {
            //Primary sort by Odds, secondary sort by horse number
            var res = Array.getValues(lines);
            res.sort(chainSort(function (l1, l2) {
                var l1sp = (l1.LineTypeID == 24 && l1.Odds == 0 ? 1 : 0);
                var l2sp = (l2.LineTypeID == 24 && l2.Odds == 0 ? 1 : 0);
                if (l1sp > l2sp) {
                    return 1;
                }
                if (l1sp < l2sp) {
                    return -1;
                }
                return 0;
            }, function (l1, l2) {
                if (l1.Odds > l2.Odds) {
                    return 1;
                }
                if (l1.Odds < l2.Odds) {
                    return -1;
                }
                return 0;
            }, function (l1, l2) {
                var rc1 = racecardInfo[l1.ID];
                var rc2 = racecardInfo[l2.ID];
                if (rc1 && rc2) {
                    if (rc1.HorseNumber > rc2.HorseNumber) {
                        return 1;
                    }
                    if (rc1.HorseNumber < rc2.HorseNumber) {
                        return -1;
                    }
                }
                return 0;
            }));
            return res;
        };
        var shouldSkipMessage = function (message) {
            if (message.data[0].receiverIds.length > 0) {
                return message.data[0].receiverIds.every(r => r !== BsUtilReceivers.FullBetSlip);
            }
            return false;
        };
        /* jshint maxcomplexity: 5 */
        api.isEmptyDepositObject = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] > 0) {
                    return false;
                }
            }
            return true;
        };
        api.getBetLoyaltyPoints = function (purchData, bet) {
            return Array.find(purchData.LoyaltyPointsPromotions, function (promotion) { return promotion.BetID == bet.BetID; });
        };
        api.isRelatedBet = function (purchData, bet) {
            return typeof bet.RelatedToID !== "undefined" && hasAnyRelatedBets(purchData, bet);
        };
        var hasAnyRelatedBets = function (purchData, bet) {
            return purchData.Bets.any(function (b) { return b.BetID === bet.RelatedToID; });
        };
        api.shouldUpdateBetsCounter = function (purchData, bet) {
            return !bet.IsEachWay && hasAnyRelatedBets(purchData, bet);
        };
        api.getLoyaltyPoints = function (placedBet, isEachWayBet) {
            if (isEachWayBet) {
                return placedBet.EWLoyaltyPointsPromotions;
            }
            else {
                return placedBet.LoyaltyPointsPromotions;
            }
        };
        api.addLoyaltyPointsForEWBets = function (bets, bet) {
            //searching in already created bets because main bet is always before those related to it
            var relatedBet = bets.find(function (b) { return b.BetID === bet.RelatedToID; });
            relatedBet.EWLoyaltyPointsPromotions = bet.LoyaltyPointsPromotions;
        };
        api.setEWLoyaltyPoints = function (bets, betData) {
            if (betData.IsEachWay) {
                BetSlipUtil.addLoyaltyPointsForEWBets(bets, betData);
            }
        };
        api.getLineType = function () {
            return BetSlip.CurrentMode.SelectionDrawType;
        };
        api.getSelectionType = function (selection) {
            switch (true) {
                case (selection instanceof RegularSlipSelection || selection instanceof RegularLiveSlipSelection):
                    return "regularSelection";
                case (selection instanceof MultiLineItem):
                    return "multiLineSelection";
                case (selection instanceof QASlipSelection || selection instanceof QALiveSlipSelection):
                    return "QASelection";
                default:
                    return false;
            }
        };
        api.hasEachWay = function (selection, mode, context) {
            if (shouldHideEachWay()) {
                return false;
            }
            return (context.isPurchase || !Modes.isSingleMode(mode) || !selection.IsEachWayEnabled || Modes.isCombinatorMode(mode)) ? false : true;
        };
        api.getSelectionEachWayIncluded = function (selection, context) {
            var selectionEachWayIncluded = false;
            if (IsUKBetSlip) {
                selectionEachWayIncluded = context.isPurchase ?
                    selection.EachWaySingleIncluded || (context.shouldShowEW && selection.EachWayMultiplesIncluded) :
                    selection.EachWaySingleIncluded || selection.EachWayMultiplesIncluded;
            }
            else {
                selectionEachWayIncluded = selection.EachWayIncluded;
            }
            return selectionEachWayIncluded;
        };
        api.isVirtualSport = function (branchID) {
            return branchID === eBranches.VirtualSports;
        };
        api.getPickLineOdds = function (mode, selection, context, skipEW) {
            var odds = Selections.getFormattedOdds(mode, selection, context);
            if (context.isPurchase && Selections.isEachwayIncluded(mode, selection, context) && !skipEW) {
                odds = Selections.getFormattedOddsEW(mode, selection, context);
            }
            return odds;
        };
        api.getQAOdds = function (mode, selection, context, spOptions) {
            var odds = Selections.getFormattedOdds(mode, selection, context);
            if (spOptions.second == 0) {
                spOptions.second = "SP";
            }
            return odds;
        };
        /* tslint:disable:cyclomatic-complexity */
        api.hasOverlay = function (mode, selection) {
            var hasOverlay = selection.Error && (selection.Danger || selection.LineClosed || !selection.Valid);
            if (!Modes.isCombinatorMode(mode) && selection.ComboBetIsEnabled === undefined) {
                hasOverlay = hasOverlay && selection.ComboBetIsEnabled;
            }
            if (BetSlip.isComboNoCombinationSingleMode()) {
                hasOverlay = !selection.ComboBetIsEnabled && BetSlip.getSelectionsCount() > 1;
            }
            return hasOverlay;
        };
        api.notBuildComboOptions = function (mode, selections) {
            return Object.keys(selections).length === 0 ||
                (BetSlip.isComboNoCombinationSingleMode(mode) && Object.keys(selections).length > 1 && Array.getLength(mode.getSelectionsInCombo()) === 0);
        };
        api.notBuildUKMultiplesOptions = function (selections) {
            return Object.keys(selections).length === 0 || BetSlip.getSelectionsCount() < 2;
        };
        api.shouldBuildQuickStake = function (mode) {
            return (mode instanceof ComboNoCombinationSPSlipMode || Modes.isComboNoCombinationSingleMode(mode)) && QuickStake.isAvailable();
        };
        /* tslint:disable:cyclomatic-complexity */
        api.buildCheckBoxContextForMultiOptions = function (mode, options, type) {
            var context = {};
            var checkedClass = getIsChecked(mode, options);
            if (type == "default") {
                if ((typeof ComboSPSlipMode !== "undefined" && mode instanceof ComboSPSlipMode) ||
                    (typeof ComboSlipMode !== "undefined" && mode instanceof ComboSlipMode) ||
                    (typeof ComboNoCombinationSPSlipMode !== "undefined" && mode instanceof ComboNoCombinationSPSlipMode) ||
                    Modes.isComboNoCombinationSingleMode(mode)) {
                    context.id = api.getDefaultEachWayBoxID(options);
                    context.onClick = "UniSlipBlock.updateEachWay({0})".format(options.key);
                }
                if ((typeof SystemSPSlipMode !== "undefined" && mode instanceof SystemSPSlipMode) ||
                    (typeof SystemSlipMode !== "undefined" && mode instanceof SystemSlipMode)) {
                    context.id = api.getDefaultEachWayBoxID(options);
                    context.onClick = "UniSlipBlock.updateEachWay(this)";
                }
            }
            //UK
            else if (type == "uk") {
                if ((options.ukSubMode == UKSlipModeSubModes.System && mode.SelectedSystemEWVariants[options.key]) ||
                    (options.ukSubMode != UKSlipModeSubModes.System && mode.CheckForEachWayIncluded(options.key, true))) {
                    checkedClass = "checked";
                }
                if (typeof UKSPSlipMode !== "undefined" && mode instanceof UKSPSlipMode) {
                    context.id = api.getUKEachWayBoxID(options);
                    var ukSubMode = options.ukSubMode == UKSlipModeSubModes.System ? UKSlipModeSubModes.System : UKSlipModeSubModes.Combo;
                    context.onClick = `UniSlipBlock.updateEachWay(${options.key},${ukSubMode})`;
                }
            }
            context.checked = checkedClass;
            return context;
        };
        api.getDefaultEachWayBoxID = function (options) {
            return "eachWayOpt-" + options.key;
        };
        api.getUKEachWayBoxID = function (options) {
            return `eachWayOpt-${(options.systemName ? "system" : "combo")}-${options.key}`;
        };
        /* tslint:disable:cyclomatic-complexity */
        var getIsChecked = function (mode, options) {
            switch (true) {
                //Combo
                case (((typeof ComboSPSlipMode !== "undefined" && mode instanceof ComboSPSlipMode) ||
                    (typeof ComboNoCombinationSPSlipMode !== "undefined" && mode instanceof ComboNoCombinationSPSlipMode) ||
                    Modes.isComboNoCombinationSingleMode(mode)) && Modes.isMultiEWVariantChecked(mode, options.key)) ||
                    (typeof ComboSlipMode !== "undefined" && mode instanceof ComboSlipMode && Modes.isMultiEWVariantChecked(mode, options.key)):
                    return "checked";
                //System
                case (typeof SystemSPSlipMode !== "undefined" && mode instanceof SystemSPSlipMode && options.ewIncluded):
                    return "checked";
                default:
                    return "";
            }
        };
        api.getComboStakeBoxID = function (options) {
            return IsUKBetSlip ? "stakebox_combo_" + options.key : "stakebox_" + options.key;
        };
        api.getSystemStakeBoxID = function (options) {
            return IsUKBetSlip ? "stakebox_system_" + options.key : "stakebox_system";
        };
        api.hideSelectionCheckbox = function (selection, mode) {
            return !selection.ComboRate || BetSlip.showCheckBoxes === 0 || Modes.isCombinatorMode(mode);
        };
        api.isSingleSelection = function (selectionCount) {
            return selectionCount === 1 && BetSlip.TemplateType === 2;
        };
        api.showComboBonusInfo = function (mode, key) {
            return ComboBonusProvider.ComboBonuses && ComboBonusProvider.ComboBonuses[key] && !mode.EachWayIncluded && !mode.NamedSystemOdds[key];
        };
        api.hideBuyPointsSelect = function (mode) {
            return (typeof TeaserSPSlipMode !== "undefined" && mode instanceof TeaserSPSlipMode);
        };
        api.showNAForRelatedSelections = function () {
            return BetSlip.DisplayNARelatedSelections && Modes.showComboNotAllowedMessage(BetSlip.CurrentMode);
        };
        api.loadData = loadData;
        api.loadDataSuccessCallback = function (betslipHandler, betslipData) {
            betslipData.forEach(function (bsItem) {
                betslipHandler(getLegacySelectionData(bsItem.event, bsItem.market, bsItem.selection));
            });
        };
        api.loadDataErrorCallBack = function (error) {
            console.error(error);
            // TODO: Send status msg with error
        };
        api.processMessage = function (message) {
            if (shouldSkipMessage(message)) {
                return;
            }
            var action = getBetslipAction(message.subChannel);
            if (message.data[0].items && message.data[0].items.length > 0) {
                const item = message.data[0].items[0];
                if (action == BetSlipActions.Add) {
                    if (item.racingCastBetPosition !== undefined) {
                        api.handleForcastTricastMessage(message.data[0].items);
                        return api;
                    }
                    if (item["legacy"] && item["legacy"]) {
                        api.handleQAOddHRMessage(message.data[0].items[0]);
                        return api;
                    }
                }
                if (action == BetSlipActions.Remove && tryRemoveHRBet(item)) {
                    return api;
                }
            }
            switch (action) {
                case BetSlipActions.Clear:
                    api.clearAll();
                    break;
                case BetSlipActions.Status:
                    api.getSelections();
                    break;
                default:
                    api.loadData(bffGateway, message.data[0].items, api.loadDataSuccessCallback.bind(api, getMessageHandler(action)), api.loadDataErrorCallBack);
                    break;
            }
        };
        return api;
    }()));
};
BetSlipUtilExtend(window, BFFGateway, internalMessageBus, BetSlip);
//# sourceMappingURL=BetSlipUtil.js.map